interface IWindow {
    googletag: any
    getComputedStyle: any
}

declare let window: IWindow

/**
 * Ad block detection functions
 */
export const AdBlockDetection = {
    adsHidden: false,
    googletagMissing: false,
    pianoDetection: false,
    detectHiddenAds(): boolean {
        /**
         * Detects if the first ad position has been hidden
         */
        const ad1 = document.getElementById('ad-1')
        if (!ad1) {
            return false
        }

        const adComputedStyle = window.getComputedStyle(ad1)
        if (ad1.offsetHeight === 0 || adComputedStyle.display === 'none' || adComputedStyle.visibility === 'hidden') {
            return true
        }
        return false
    },

    detectGoogletagMissing(): boolean {
        /**
         * Detects if the googletag ad service network request has been blocked
         */

        if (typeof window.googletag === 'undefined' || typeof window.googletag._loadStarted_ === 'undefined') {
            return true
        }
        return false
    },

    detectWithPiano(): boolean {
        /**
         * Checks if Piano has detected an ad blocker (words for ABP, AB, and uBlock)
         */
        const detected = (document.cookie.split(';').find((c) =>
                    c.trim().startsWith(`__adblocker=`)) || '').trim().split('=').pop() === 'true'
        return detected
    },

    detectAdBlock(): boolean {
        /**
         * Calls all methods related to detecting ads
         */
        AdBlockDetection.adsHidden = AdBlockDetection.detectHiddenAds()
        AdBlockDetection.googletagMissing = AdBlockDetection.detectGoogletagMissing()
        AdBlockDetection.pianoDetection = AdBlockDetection.detectWithPiano()
        return AdBlockDetection.adsHidden || AdBlockDetection.googletagMissing || AdBlockDetection.pianoDetection
    },

    fixAdSpacing(): void {
        /**
         * Fixes the spacing around an ad that has been hidden by adblock
         */
        const adElements = document.getElementsByClassName('ad__section-border--category')
        for (const ad of Array.from(adElements)) {
            const bufferElement = document.createElement('div')
            bufferElement.style.height = '20px'
            bufferElement.className = 'buffer'

            if (ad.nextSibling) {
                ad.parentNode.insertBefore(bufferElement, ad.nextSibling)
            } else {
                ad.parentNode.appendChild(bufferElement)
            }
        }
    }
}
